import { formatCheckBoxValue } from '@flowus/common/block/checkbox-value';
import type { BlockDTO, CollectionViewType } from '@next-space/fe-api-idl';
import { BlockType } from '@next-space/fe-api-idl';
import { ViewNameMap } from 'src/bitable/bitable-manager/const';
import { message } from 'src/common/components/message';
import { fetchCollection, getPropertyValue } from 'src/common/utils/fetch-collection';
// const COLLECTION_ID = '14620f35-b0be-4d28-8a10-f3ae4809af43';
// const VIEW_ID = 'e077dd8f-a2d7-46e6-a97e-3167cf8665e0';

// const OPTION_PAGE_NAME = '文档';
const OPTION_COLLECTION_NAME = __BUILD_IN__ ? 'Database' : '多维表';
const OPTION_FOLDER_NAME = __BUILD_IN__ ? '' : '文件夹';
const OPTION_AI = 'AI';

const COLUMN_PAGE_TYPE_NAME = __BUILD_IN__ ? 'Page type' : '页面类型';
const COLUMN_COLLECTION_VIEW_NAME = __BUILD_IN__ ? 'Database view type' : '多维表视图';
const COLUMN_TITLE_NAME = __BUILD_IN__ ? 'Title' : '文档大标题';
const COLUMN_DESC_NAME = __BUILD_IN__ ? 'Sub title' : '文档小标题';
const COLUMN_PAGE_ICON_NAME = __BUILD_IN__ ? 'Icon' : '文档配图';
const COLUMN_URL_NAME = __BUILD_IN__ ? 'Link' : '跳转地址';
const COLUMN_PUBLISH_NAME = __BUILD_IN__ ? 'Online' : '上线';

interface PageInfo {
  blockType: BlockType;
  viewType?: CollectionViewType;
}
export interface RecommendPage {
  blockId: string;
  title: string;
  desc: string;
  url: string;
  icon?: string;
}

/** 帮助面板拉取 推荐的页面 */
export const fetchRecommendPages = async (info: PageInfo) => {
  // 如果.env.local没配置的话用默认的test环境
  const COLLECTION_ID =
    import.meta.env.VITE_SERVICE_CENTER_COLLECTION_ID?.split('|')[0] ??
    '1ef93ed3-560f-40d6-9ba6-167f1035c115';
  const VIEW_ID =
    import.meta.env.VITE_SERVICE_CENTER_COLLECTION_ID?.split('|')[1] ??
    '350411c0-0f76-4c55-9ece-ee0824fb667f';

  const pages = await fetchCollection<RecommendPage>(COLLECTION_ID, {
    onError: (err) => {
      message.error(`拉取推荐文档失败[${err.msg}]`);
    },
    getViewId: () => VIEW_ID,
    convertToTargets: (blocks: BlockDTO[], _, propertyMapping) => {
      return blocks.map((b) => {
        const item: RecommendPage = {
          blockId: b.uuid,
          title: getPropertyValue(b, propertyMapping, COLUMN_TITLE_NAME),
          desc: getPropertyValue(b, propertyMapping, COLUMN_DESC_NAME),
          url: getPropertyValue(b, propertyMapping, COLUMN_URL_NAME),
          icon: getPropertyValue(b, propertyMapping, COLUMN_PAGE_ICON_NAME),
        };
        return item;
      });
    },
    filter: (item, _, propertyMapping) => {
      const publish = formatCheckBoxValue(
        getPropertyValue(item, propertyMapping, COLUMN_PUBLISH_NAME)
      );
      if (!publish) return false;
      const blockTypeName = getPropertyValue(item, propertyMapping, COLUMN_PAGE_TYPE_NAME);
      if (!blockTypeName) return false;
      const collectionViewName = getPropertyValue(
        item,
        propertyMapping,
        COLUMN_COLLECTION_VIEW_NAME
      );
      if (info.viewType) {
        // @ts-ignore type
        const viewName = ViewNameMap[info.viewType];
        if (viewName && !collectionViewName.includes(viewName)) {
          return false;
        }
      }
      // 当前记录符合哪种页面类型
      let blockTypes = [BlockType.PAGE];
      if (blockTypeName === OPTION_COLLECTION_NAME) {
        blockTypes = [
          BlockType.COLLECTION_VIEW,
          BlockType.COLLECTION_VIEW_PAGE,
          BlockType.REFERENCE_COLLECTION,
          BlockType.REFERENCE_COLLECTION_PAGE,
        ];
      } else if (blockTypeName === OPTION_FOLDER_NAME) {
        blockTypes = [BlockType.FOLDER];
      } else if (blockTypeName === OPTION_AI) {
        return true;
      }
      // 跟当前页面对比，匹配符合的
      return blockTypes.includes(info.blockType);
    },
  });
  return pages;
};
